import { LIVES_START, SCORE } from './Constants.js';

class GameState {
  constructor() {
    this.reset();
  }

  reset() {
    this.time = 0; // shared monotonic clock, advanced by Game each frame

    this.game = {
      started: false,
      isPlaying: false,
      paused: false,
      over: false,
      muted: false,
      isDemo: true,
    };

    this.run = {
      score: 0,
      lives: LIVES_START,
      level: 1,
      childrenCount: 0,
      best: this.run ? this.run.best || 0 : 0,
    };

    this.player = {
      // grid/world position — x is continuous (flatcars carry the player),
      // row is a whole-number lane index counted from the start bank.
      x: 0,
      row: 0,
      maxRow: 0,
      hopping: false,
      dead: true,
      invulnUntil: 0,
      carrier: null, // the consist currently carrying the player, if any
    };

    this.level = {
      rows: [],
      goalRow: 0,
      startedAt: 0,
    };
  }

  /** Fresh crossing on the same level — keeps score/lives/level. */
  resetRun(now) {
    this.player.x = 0;
    this.player.row = 0;
    this.player.maxRow = 0;
    this.player.hopping = false;
    this.player.dead = false;
    this.player.carrier = null;
    this.level.startedAt = now;
  }

  timeBonus(now) {
    const elapsed = now - this.level.startedAt;
    const left = Math.max(0, SCORE.RUN_TIME_LIMIT - elapsed);
    return Math.round(left) * SCORE.TIME_BONUS_PER_SEC;
  }
}

export const gameState = new GameState();
